// Get inventory data...
let inventoryData = {};
fetch('/collections/all?view=inventory')
    .then(r => r.json())
    .then(data => {
        data.variants.forEach(v => {
            inventoryData[v.id] = {
                inventory: parseInt(v.inventory, 10),
                threshold: parseInt(v.threshold, 10),
            };
        });
    });

// Validate cart contents...
async function validateCart(cart) {
    if ( !cart || !Array.isArray(cart.items) ) {
        return false;
    }
    for ( const item of cart.items ) {
        
        // Skip validation for pre-order line items...
        if ( item.properties && Object.prototype.hasOwnProperty.call(item.properties, 'preorder') ) {
            continue;
        }
        const variant = inventoryData[item.id];
        if ( !variant ) {
            continue;
        }

        // Check inventory against threshold, if fails...
        const maxAllowed = variant.inventory - variant.threshold;
        if ( item.quantity > maxAllowed ) {
            
            // Return message to user...
            if ( maxAllowed === 1 ) {
                alert(`There's only 1 item left in stock.`);
            } else {
                alert(`There's only ${maxAllowed} items left in stock.`);
            }

            // Correct the quantity...
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                id: item.key,
                quantity: maxAllowed
                })
            });

            // Reload AFTER successful update...
            window.location.reload();
            return false;
        }
    }
    return true;
}

// Listen for Shopify cart events...
(function() {
    
    const ShopifyCartURLs = [
        '/cart/add.js',
        '/cart/change.js',
        '/cart/update.js',
        '/cart/clear.js',
        '/cart/add',
        '/cart/change',
        '/cart/update',
        '/cart/clear',
    ];

    function isShopifyCartURL(url) {
        if ( !url || typeof url !== 'string' ) return false;
        return ShopifyCartURLs.some(path => url.includes(path));
    }

    function dispatchCartEvent(url, data) {
        window.dispatchEvent(new CustomEvent('SCE:mutate', { detail: data }));
        const method = url.split("/").pop();
        window.dispatchEvent(new CustomEvent(`SCE:${method}`, { detail: data }));
    }


    // Override XHR...
    const originalXhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
        this._url = url;
        return originalXhrOpen.apply(this, arguments);
    };

    const originalXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(body) {
        this.addEventListener('load', () => {
            if ( isShopifyCartURL(this._url) ) {
                try {
                    const response = JSON.parse(this.responseText);
                    dispatchCartEvent(this._url, response);
                } catch (e) {
                    //console.warn('Failed to parse XHR cart response', e);
                }
            }
        });
        return originalXhrSend.apply(this, arguments);
    };

    // Safe fetch override...
    const originalFetch = window.fetch;

    window.fetch = function(...args) {
        const url = args[0];
        const fetchPromise = originalFetch.apply(this, args);

        // Only intercept cart API calls...
        if ( !isShopifyCartURL(url) ) return fetchPromise;

        fetchPromise.then(res => {
            // Ensure it's actually a 'Response' object...
            if ( !(res instanceof Response) ) {
                //console.warn("Fetch patch: non-Response returned:", res);
                return;
            }
            res.clone().json()
            .then(data => {
                dispatchCartEvent(url, data);
            })
            .catch(() => { /* Non-JSON response ignored safely */ });
        });

        return fetchPromise;
    };

})();


// Refetch cart prior to running validation...
async function runValidation() {
    try {
        const cart = await fetch('/cart.js').then(r => r.json());
        await validateCart(cart);
    } catch (err) {
        //console.error('Failed to validate cart:', err);
    }
}

// Listen for add.js, change.js and update.js cart API mutations...
window.addEventListener('SCE:add.js', runValidation);
window.addEventListener('SCE:change.js', runValidation);
window.addEventListener('SCE:update.js', runValidation);